import { useQuery } from '@apollo/react-hooks';
import Popover from '@material-ui/core/Popover';

import AccountSwitch from '~/components/AccountSwitch';
import CompanyLogo from '~/components/CompanyLogo';
import HelpIcon from '~/images/Navigation/UserMenu/HelpIcon.svg';
import LogoutIcon from '~/images/Navigation/UserMenu/Logout.svg';

import EditProfile from './EditProfile.svg';
import query from './query.graphql';
import styles from './styles.style';

const UserMenu = ({
  classes,
  accounts,
  currentAccountId,
  currentUser,
  domain,
}) => {
  if (!currentUser) return null;
  const { name, email } = currentUser;

  return (
    <div className={classes.root}>
      <div className={classnames(classes.personDetails, classes.section)}>
        <CompanyLogo
          size={48}
          domain={domain}
          className={classes.companyIcon}
        />
        <div className={classes.personDetailsText}>
          <span className={classes.name}>{name}</span>
          <span className={classes.email}>{email}</span>
          <a
            className={classes.editProfile}
            href="https://dashboard.clearbit.com/profile"
            target="_blank"
            rel="noopener noreferrer">
            Edit profile
            <EditProfile />
          </a>
        </div>
      </div>
      <AccountSwitch
        accounts={accounts}
        currentAccountId={currentAccountId}
        currentUser={currentUser}
      />
      <div className={classnames(classes.section, classes.actions)}>
        <a
          className={classes.actionLink}
          rel="noopener noreferrer"
          target="_blank"
          href="https://help.clearbit.com/hc/en-us/categories/360001739433-Clearbit-X">
          <HelpIcon />
          Support & Guides
        </a>
        <a className={classes.actionLink} href="/logout">
          <LogoutIcon className={classes.logoutLinkIcon} />
          Sign out
        </a>
      </div>
    </div>
  );
};

const WrappedUserMenu = (props) => {
  const { data } = useQuery(query, { returnPartialData: true });

  if (!data.viewer || !data.account) return null;

  return (
    <Popover {...props.popoverProps}>
      <UserMenu
        {...props}
        accounts={data.viewer.user?.accounts || []}
        currentAccountId={data.account.id}
        currentUser={data.viewer.user}
        domain={data.account.domain}
      />
    </Popover>
  );
};

UserMenu.propTypes = {
  classes: PropTypes.object,
  accounts: PropTypes.array,
  currentAccountId: PropTypes.string,
  currentUser: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  domain: PropTypes.string,
};

WrappedUserMenu.propTypes = {
  popoverProps: PropTypes.object,
};

export const StyledUserMenu = withStyles(styles)(UserMenu);

export default withStyles(styles)(WrappedUserMenu);
